export const STATUS = "EMBEDDED_STATUS";
export const REFERENCED_ORDER = "APPDATA_REFERENCED_ORDER";
export const FITTING = "EMBEDDED_FITTING";
export const CLEAR_REFERENCED_ORDER_STATE = "APPDATA_CLEAR_ORDER_STATE";
